// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"1419d747","81":"779430f1","445":"954c35cf","459":"3def95ed","984":"a6d23061"}[chunkId] + ".chunk.css";
};